import React, { useState } from "react";
import type { FormattedInvoicePayload } from "../formattedInvoice/formattedInvoiceData";
import { resolveNativeImageSource } from "./nativeLayout.mjs";

export default function NativeReportImage({ payload, reference, fit, className, missingClassName }: {
  payload: FormattedInvoicePayload;
  reference?: string;
  fit?: string;
  className?: string;
  missingClassName?: string;
}) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  const { src, error, unavailable } = resolveNativeImageSource(payload, reference);
  const decodeFailed = Boolean(src && failedSource === src);
  if (!src || decodeFailed) {
    const invalid = decodeFailed || !unavailable;
    const message = decodeFailed ? `Image "${reference || ""}" could not be decoded.` : error || "Missing image";
    return <span className={missingClassName} role={invalid ? "alert" : "img"} aria-label={message} title={message}>{invalid ? "Invalid image" : "Missing image"}</span>;
  }
  return <img alt={reference === "companyLogo" || reference === "company-logo" ? "Company logo" : "Report image"} className={className} src={src} onError={() => setFailedSource(src)} style={{ width: "100%", height: "100%", objectFit: fit === "stretch" ? "fill" : fit === "cover" ? "cover" : "contain", objectPosition: "center" }} />;
}
